import { Card } from "react-bootstrap";
import PropTypes from 'prop-types';

function StatCardCompact({ title, value, subtitle, icon, iconColor, valueColor }) {
  const iconBackgroundColors = {
    blue: "#e3f2fd",
    green: "#e8f5e9",
    cyan: "#e0f7fa",
    yellow: "#fff9e6",
    orange: "#fff3e0",
    purple: "#f3e5f5",
    red: "#ffebee",
  };

  const iconColors = {
    blue: "#2196f3",
    green: "#4caf50",
    cyan: "#00bcd4",
    yellow: "#ffc107",
    orange: "#ff9800",
    purple: "#9c27b0",
    red: "#f44336",
  };

  const valueColors = {
    blue: "#1976d2",
    green: "#2e7d32",
    cyan: "#00acc1",
    yellow: "#f57f17",
    orange: "#e65100",
    purple: "#6a1b9a",
    red: "#c62828",
  };

  return (
    <Card className="shadow-sm border-0 h-100">
      <Card.Body className="d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <h6 className="text-muted mb-2" style={{ fontSize: "0.95rem", fontWeight: "400" }}>
              {title}
            </h6>
            <h3 
              className="mb-0" 
              style={{ 
                fontSize: "1.5rem", 
                fontWeight: "600",
                color: valueColors[valueColor] || valueColors.blue,
                lineHeight: "1.3"
              }}
            >
              {value}
            </h3>
          </div>
          <div
            className="d-flex align-items-center justify-content-center rounded"
            style={{
              width: "60px",
              height: "60px",
              backgroundColor: iconBackgroundColors[iconColor] || iconBackgroundColors.blue,
              flexShrink: 0,
            }}
          >
            <i 
              className={icon} 
              style={{ 
                fontSize: "1.8rem", 
                color: iconColors[iconColor] || iconColors.blue
              }}
            ></i>
          </div>
        </div>
        <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
          {subtitle}
        </p>
      </Card.Body>
    </Card>
  );
}

StatCardCompact.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.oneOf(['blue', 'green', 'cyan', 'yellow', 'orange', 'purple', 'red']),
  valueColor: PropTypes.oneOf(['blue', 'green', 'cyan', 'yellow', 'orange', 'purple', 'red']),
};

StatCardCompact.defaultProps = {
  iconColor: 'blue',
  valueColor: 'blue',
};

export default StatCardCompact;
